// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"53790280","977":"fd04ce78"}[chunkId] + ".chunk.js";
};